const featuredlistingsdata = [
  {
    id: 1,
    businessname: 'VisionRsoft',
    title: 'VisionRsoft',
    businesstype: 'Information Technology Services',
    locationname: 'Mangalore',
    areaname: '',
    address1: 'VisionRsoft',
    aboutdescription: 'Information Technology consulting for your businesses.',
    contactperson: 'Oswald R',
    contactnumber: '',
    imagepath: '/images/homefeatured/itconsultancy_visionrsoft_home1.jpg',
    website: 'http://www.visionrsoft.com',
    photos: [
      '/images/homefeatured/itconsultancy_visionrsoft_s1.jpg',
      '/images/homefeatured/itconsultancy_visionrsoft_s2.jpg',
      '/images/homefeatured/itconsultancy_visionrsoft_s3.jpg',
    ],
    featuredListings: true,
    listingorder: 1,
    dateposted: '2025-05-10T10:00:00Z',
    sm_insta: 'https://instagram.com/visionrsoftware',
    sm_facebook: 'https://facebook.com/visionrsoftware',
    sm_whatsapp: '',
    sm_youtube: 'https://youtube.com/visionrsoftware',
    accountstatus: 'Active',
  },
  {
    id: 3,
    businessname: 'Ronita Realty',
    title: 'Ronita Realty',
    businesstype: 'Real Estate',
    locationname: 'Mumbai',
    areaname: 'I.C. Colony, Borivali West',
    address1: ' Shop No. 2, Dipti Blossom, I. C. Colony, Borivali West, Mumbai-400103',
    aboutdescription: 'Ronita Realty brings specialized local expertise to Borivali West and surrounding areas, delivering tailored real estate solutions centered around your success. Our team is firmly committed to client satisfaction, delivering comprehensive, tailored solutions that match your unique goals.Our Core Services🏡 Buying – Find your dream residential or commercial space.💰 Selling – Market your property effectively for the best returns.📊 Property Management – Protect and maximize your real estate investments.Why Choose Us?Expert Guidance: We are with you every single step of the way.Personalized Approach: Solutions customized to your exact needs.Lasting Value: Built on professional, reliable, and transparent services.',
    contactperson: 'Robert Gonsalves',
    contactnumber: '919892764760, 919930831760',
    imagepath: '/images/homefeatured/realty_ronita_ronitarealty_home1.jpg',
    website: '',
    photos: [
      '/images/homefeatured/realty_ronita_ronitarealty_s1.png',
      '/images/homefeatured/realty_ronita_ronitarealty_home1.jpg',
      '/images/homefeatured/realty_ronita_ronitarealty_s2.png',    ],
    featuredListings: true,
    listingorder: 2,
    dateposted: '2026-02-01T09:00:00Z',
    sm_insta: 'https://instagram.com/realtyronita',
    sm_facebook: 'https://facebook.com/realtyronita',
    sm_whatsapp: 'https://wa.me/919892764760',
    sm_youtube: 'https://youtube.com/realtyronita',
    accountstatus: 'Active',
  },

  {
    id: 3,
    businessname: 'Victory Fibers',
    title: 'Victory Fibers',
    businesstype: 'Fiber Door Manufacturers',
    locationname: 'Kundapura',
    areaname: 'Church Road',
    address1: 'Victory Fibers, Near Mangalore Tile Works, River side, Church Road, Kundapura',
    aboutdescription: 'High-quality fiber doors for residential and commercial use. Durable and stylish designs.',
    contactperson: 'Loy Carvalho',
    contactnumber: '919343090441',
    imagepath: '/images/homefeatured/gs_fibre_loy_victoryfibres_home1.jpg',
    website: '',
    photos: [
      '/images/homefeatured/gs_fibre_loy_victoryfibres_s1.jpg',
      '/images/homefeatured/gs_fibre_loy_victoryfibres_s2.jpg',
      '/images/homefeatured/gs_fibre_loy_victoryfibres_s3.jpg',
      '/images/homefeatured/loy_victoryfibers_s4.jpg',
    ],
    featuredListings: true,
    listingorder: 3,
    dateposted: '2026-02-01T09:00:00Z',
    sm_insta: 'https://instagram.com/victoryfibers',
    sm_facebook: 'https://facebook.com/victoryfibers',
    sm_whatsapp: 'https://wa.me/919343090441',
    sm_youtube: 'https://youtube.com/victoryfibers',
    accountstatus: 'Active',
  },
  {
    id: 4,
    businessname: 'Weldone Decorators',
    title: 'Weldone Decorators',
    businesstype: 'Decorators',
    locationname: 'Mangalore',
    areaname: 'Jeppu-Valencia',
    address1: 'Weldone Decorators, Jeppu-Valencia, Mangalore',
    aboutdescription: 'Home and event decoration specialists.',
    contactperson: 'Melvin Fernandes',
    contactnumber: '919845333031',
    imagepath: '/images/homefeatured/ep_decor_melvinfern_home1.jpg',
    photos: [
      '/images/homefeatured/ep_decor_melvinfern_s1.jpg',
      '/images/homefeatured/ep_decor_melvinfern_s2.png',
      '/images/homefeatured/ep_decor_melvinfern_s3.jpg',
      '/images/homefeatured/ep_decor_melvinfern_s4.jpg',
      '/images/homefeatured/ep_decor_melvinfern_s5.jpg',
    ],
    featuredListings: true,
    listingorder: 5,
    dateposted: 'Nov 23, 2025, 9:00 AM',
    sm_insta: 'https://instagram.com/weldonedecorators',
    sm_facebook: 'https://facebook.com/weldonedecorators',
    sm_whatsapp: 'https://wa.me/9198#####789',
    sm_youtube: 'https://youtube.com/weldonedecorators',
    accountstatus: 'Active',
  },
  {
    id: 5,
    businessname: 'Pinto Enclave',
    title: 'Pinto Enclave',
    businesstype: 'Venue Hall',
    locationname: 'Mangalore',
    areaname: 'Bondel - Pachanady',
    address1: 'Pinto Enclave, Bondel - Pachanady, Mangalore',
    aboutdescription: 'Spacious venue hall for weddings and events.',
    contactperson: 'Vinu',
    contactnumber: '98########9',
    imagepath: '/images/homefeatured/ep_venue_vinod_pintoenclave_home1.avif',
    website: 'https://pinto-enclave.example.com',
    photos: [
      '/images/homefeatured/ep_venue_vinod_pintoenclave_s1.jpg',
      '/images/homefeatured/ep_venue_vinod_pintoenclave_s2.jpg',
      '/images/homefeatured/ep_venue_vinod_pintoenclave_s4.jpg',
    ],
    featuredListings: true,
    listingorder: 3,
    dateposted: 'Nov 23, 2025, 9:00 AM',
    sm_insta: 'https://instagram.com/pintoenclave',
    sm_facebook: 'https://facebook.com/pintoenclave',
    sm_whatsapp: 'https://wa.me/9198#####789',
    sm_youtube: 'https://youtube.com/pintoenclave',
    accountstatus: 'Active',
  },
  {
    id: 6,
    businessname: 'Bharath Transport',
    title: 'Bharath Transport',
    businesstype: 'transport',
    locationname: 'Kundapura',
    areaname: 'Kunnapura Town',
    address1: 'Bharath Transport, Kunnapura Town, Kundapura',
    aboutdescription: 'Reliable and efficient transport services for all your needs.',
    contactperson: 'Dinesh Bhandari',
    contactnumber: '917975715868',
    imagepath: '/images/homefeatured/gs_transport_dineshb_bharathtransport_home1.jpg',
    website: '0',
    photos: [
      '/images/homefeatured/gs_transport_dineshb_bharathtransport_home1.jpg',
      '/images/homefeatured/gs_transport_dineshb_bharathtransport_s1.jpg',
      '/images/homefeatured/gs_transport_dineshb_bharathtransport_s3.jpg',
    ],
    featuredListings: true,
    listingorder: 4,
    dateposted: 'Feb 19, 2026, 10:00 AM',
    sm_insta: 'https://instagram.com/bharathtransportdinesh',
    sm_facebook: '',
    sm_whatsapp: 'https://wa.me/917975715868',
    sm_youtube: '',
    accountstatus: 'Active',
  },
  {
    id: 6,
    businessname: 'Sequira DJ',
    title: 'Sequira DJ',
    businesstype: 'DJ Services',
    locationname: 'Mangalore',
    areaname: 'Kinnigoli',
    address1: 'Sequira DJ, Kinnigoli, Mangalore',
    aboutdescription: 'Professional DJ services for all types of events.',
    contactperson: 'Kevin Sequeira',
    contactnumber: '917795546832',
    imagepath: '/images/homefeatured/ep_dj_kevinsequeira_home1.jpg',
    website: '0',
    photos: [
      '/images/homefeatured/ep_dj_kevinsequeira_s1.jpg',
      '/images/homefeatured/ep_dj_kevinsequeira_s2.jpg',
      '/images/homefeatured/ep_dj_kevinsequeira_s3.jpg',
    ],
    featuredListings: true,
    listingorder: 4,
    dateposted: 'Feb 19, 2026, 10:00 AM',
    sm_insta: 'https://instagram.com/kevinsequeira05',
    sm_facebook: '',
    sm_whatsapp: 'https://wa.me/917975715868',
    sm_youtube: 'https://youtube.com/dj_kevin_sequeira',
    accountstatus: 'Active',
  },
  {
    id: 2,
    businessname: 'Rohan Sounds & Lightings',
    title: 'Rohan Sounds & Lightings',
    businesstype: 'Sounds',
    locationname: 'Mangalore',
    areaname: 'Kankanady',
    address1: 'Rohan Sounds & Lightings, Nagori-Kankanady post',
    aboutdescription: 'Professional sound and lighting services for events.',
    contactperson: 'Rohan Sequeira',
    contactnumber: '918497078769',
    imagepath: '/images/homefeatured/ep_sound_rohansequeira_home1.jpg',
    website: '0',
    photos: [
      '/images/homefeatured/ep_sound_rohansequeira_s1.jpg',
      '/images/homefeatured/ep_sound_rohansequeira_s2.jpg',
      '/images/homefeatured/ep_sound_rohansequeira_s3.jpg',
    ],
    featuredListings: true,
    listingorder: 5,
    dateposted: '2026-02-10T10:00:00Z',
    sm_insta: 'https://instagram.com/rohansounds',
    sm_youtube: 'https://youtube.com/rohansounds',
    sm_whatsapp: 'https://wa.me/9198#####123',
    sm_facebook: 'https://facebook.com/rohansounds',
    accountstatus: 'Active',
  },
  
  {
    id: 7,
    businessname: 'Hollas TV Center And Home Appliances',
    title: 'Hollas TV Center And Home Appliances',
    businesstype: 'TV and Home Appliances',
    locationname: 'Kundapura',
    areaname: 'Main Road',
    address1: 'Shankar Shet Towers, Main Road, Kundapura, Udupi district',
    aboutdescription: 'Providing a wide range of electronics and home appliances with excellent customer service.',
    contactperson: '',
    contactnumber: '+919945153097',
    imagepath: '/images/homefeatured/kundapura_electronics_hollaselectronics_home1.jpg',
    website: 'https://hollastv.in',
    photos: [
      '/images/homefeatured/kundapura_electronics_hollaselectronics_home1.jpg',
      '/images/homefeatured/kundapura_electronics_hollaselectronics_s1.jpg',
      '/images/homefeatured/kundapura_electronics_hollaselectronics_s2.jpg',
    ],
    featuredListings: true,
    listingorder: 6,
    dateposted: 'Feb 01, 2026, 10:00 AM',
    sm_insta: 'https://instagram.com/hollastvcentre',
    sm_facebook: 'https://facebook.com/hollastvcentre',
    sm_whatsapp: 'https://wa.me/919945153097',
    sm_youtube: 'https://youtube.com/hollastvcentre',
    accountstatus: 'Active',
  },
  {
    id: 8,
    businessname: 'Ferns Dream Realestate Inc.',
    title: 'Ferns Dream Realestate Inc. Mysore',
    businesstype:  'Realestate',
    locationname: 'Mysore',
    areaname: 'Airport Road',
    address1: '21234/17, 1st Cross, Mysore Road',
    aboutdescription:'We are a customer-centric real estate firm committed to delivering transparent, reliable, and value-driven property solutions. With deep market knowledge and a strong network, we assist clients in buying, selling, and leasing residential and commercial properties with confidence. Our approach combines integrity, personalized service, and attention to detail to ensure every transaction is smooth, secure, and successful.',
    contactperson: 'J##### #######',
    contactnumber: '98########9',
    imagepath: '/images/homefeatured/mysore_realestate_jfernandes_home1.jpg',
    website: 'https://example####.com',
    photos: [
      '/images/homefeatured/mysore_realestate_jfernandes_home1.jpg',
      '/images/homefeatured/mysore_realestate_jfernandes_s1.jpg',
      '/images/homefeatured/mysore_realestate_jfernandes_s2.jpg',
    ],
    featuredListings: true,
    listingorder: 4,
    dateposted: '2026-01-20T09:00:00Z',
    sm_insta: 'https://instagram.com/victoryfibers1234',
    sm_facebook: 'https://facebook.com/victoryfibers1234',
    sm_whatsapp: 'https://wa.me/91#########9',
    sm_youtube: 'https://youtube.com/victoryfibers1234',
    accountstatus: 'Active',
  },
];

export default featuredlistingsdata;
